import { DialogTitle, styled, Table, Typography } from "@mui/material";

export const StyledEditLogsContainer = {
  StyledDialogTitle: styled(DialogTitle)({
    fontWeight: "bold",
    fontSize: "18px",
  }),

  StyledTable: styled(Table)({
    minWidth: 500,
  }),

  NoDataTypography: styled(Typography)({
    textAlign: "center",
    padding: "16px",
  }),
};
